import { SET_RECOMMENDATIONS, REMOVE_RECOMMENDATIONS, ADD_RECOMMENDATION, EDIT_RECOMMENDATION } from './types'

const recommendations = (state = [], action) => {
  switch (action.type) {
    case SET_RECOMMENDATIONS:
      return action.payload
    case ADD_RECOMMENDATION:
      const recommendations = state
      let newArray = recommendations.slice()
      newArray.splice(recommendations.length, 0, action.payload)
      return newArray
    case EDIT_RECOMMENDATION:
      const { id, data } = action.payload
      const oldIndex = state.findIndex(r => r.id === id)
      console.log(oldIndex)
      const oldRecommendation = state.splice(oldIndex, 1)[0]
      const newRecom = {
        id: action.payload.id,
        date: oldRecommendation.date,
        vaccineCode: oldRecommendation.vaccineCode,
        pathologyId: oldRecommendation.pathologyId,
        doseNumber: parseInt(data.doseNumber),
        status: oldRecommendation.status,
        dateCriterion: {
          recommended: data.recommended,
          earliest: data.earliest,
          latest: data.latest
        }
      }
      let newArr = state.slice()
      newArr.splice(state.length, 0, newRecom)
      return newArr
    case REMOVE_RECOMMENDATIONS:
      return []
    default:
      return state
  }
}
export default recommendations
